import { useState, useEffect } from 'react'

import { makeStyles } from '@material-ui/core/styles';
import Box from '@material-ui/core/Box'
import Typography from '@material-ui/core/Typography'
import Button from '@material-ui/core/Button'
import Container from '@material-ui/core/Container'
import Grid from '@material-ui/core/Grid'
import api from "api/Api"
import { deviceDetect } from 'react-device-detect';
import logo from 'logo.svg';
import { useCookies } from 'react-cookie';
import Checkbox from '@material-ui/core/Checkbox';

import FormControlLabel from '@material-ui/core/FormControlLabel';

import Tooltip from '@material-ui/core/Tooltip';
import CookieConsent from "react-cookie-consent";
const useStyles = makeStyles((theme) => ({
  modal: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  }
}));

const AskView = ({ token, redirectLink, redirectConfig }) => {
  const redirect_link = (target_link) => {
    var link = document.createElement("a");
    link.referrerPolicy = "no-referrer";
    link.rel = "noreferrer";

    link.href = target_link;
    link.click();
  }

  const redirect = async (protect) => {
    let day = new Date()
    day.setTime(day.getTime() + (31556926 * 1000))
    if (protect) {
      if (remember) {
        
        setCookie('transform_policy', 'enforce', { path: "/",expires: day})
      }
      redirectLink = redirectConfig.transform_policy.redirect_target + redirectLink
      await api.callBackLog(token, redirectConfig, redirectLink, "isolation", deviceDetect())
    }
    else {
      if (remember) {
        setCookie('transform_policy', 'skip', { path: "/" ,expires: day})
      }
      await api.callBackLog(token, redirectConfig, redirectLink, "bypass", deviceDetect())
    }
    redirect_link(redirectLink)
    return null;
  }
  const classes = useStyles();
  const [second, setSecond] = useState(30)
  const [remember, setRemember] = useState(false)
  const [cookies, setCookie] = useCookies(['transform_policy']);
  const handleChange = (event) => {
    setRemember(event.target.checked)
  };

  useEffect(() => {
    let interval

    interval = setInterval(() => {
      setSecond(preSecond => {
        if (preSecond <= 1) {
          clearInterval(interval)
          redirect(true)
          return 0
        } else {
          return preSecond - 1
        }
      })
    }, 1000)

    return () => clearInterval(interval)
  }, [])
  return (
    <Grid container spacing={1} style={{ overflow: "auto" }}>
      <Grid item xs={12}  >
        <Container className={classes.modal}>
          <img style={{ "maxWidth": "20vh", height: "15vh" }} src={logo} alt="logo" />
        </Container>
      </Grid>
      <Box mb={1} >
        <Grid item xs={12} sm container style={{ justifyContent: "center" }} >
          {/* <FormGroup row> */}

          <Typography
            // className={classes.description}
            align="left"
            color="textPrimary"
            variant="subtitle1"
          >
            <Grid item xs container spacing={1} >
              <Grid item xs={12} style={{ textAlign: "-webkit-center" }}>
                <Box mt={0.5} >
                  We recommend opening this website in Green Radar isolation platform for security reasons, please press <b>Proceed with Protection now</b>.
                  <br />
                  If you are not Green Radar’s customers, please press <b> Skip Protection </b>.
                  <br />
                  You will be auto redirected to isolation platform in {second}  seconds.
                </Box>
              </Grid>
              <div className="strike" >
                <span></span>
              </div>
              <Grid item xs={12} style={{
                borderTop: "#d2d2d2",
                borderTopStyle: "groove",
                borderTopWidth: "1px",
                textAlign: "-webkit-center"
              }}>
                <Box mt={0.5} >
                  建議透過Green Radar隔離平台開啟此網站，請按<b>Proceed with Protection now</b> 立即進行保護。
                  <br />
                  若你不是grMail用戶，請按<b> Skip Protection </b>前往此網站。
                  <br />
                  你將在 {second} 秒後自動前往隔離平台。
                </Box>
              </Grid>
            </Grid>
          </Typography>

          {token ?
            <Box mt={1} style={{ textAlign: "center" }}>
              <Tooltip placement="top" title="Save your preference in browser cookie">

                <FormControlLabel
                  control={<Checkbox checked={remember} onChange={handleChange} name="checkedA" />}
                  label={<span><b>Save your preference in browser cookie</b></span>}
                />
              </Tooltip></Box> : <div />}

          {/* </FormGroup> */}
        </Grid>
      </Box>
      <Grid item xs={6} style={{ textAlign: "center", justifyContent: "center", display: "inline-flex" }}>
        <Button variant="contained" style={{ backgroundColor: "#9e9e9e", color: 'white' }} onClick={(e) => { redirect(false) }}>
          Skip Protection
        </Button>
      </Grid>
      <Grid item xs={6} style={{ textAlign: "center" }}>
        <Button variant="contained" style={{ backgroundColor: "#5DBB46", color: 'white' }} onClick={(e) => { redirect(true) }}>
          Proceed with Protection now
        </Button>
      </Grid>

      <CookieConsent>This website uses cookies to enhance the user experience.</CookieConsent>
    </Grid >
  )
}


// let expires = new Date()
//     expires.setTime(expires.getTime() + (response.data.expires_in * 1000))
//     setCookie('access_token', response.data.access_token, {path: '/',  expires})
export default AskView
